/**
 * Stytch inbound presenter — declarative metadata consumed by the
 * shared inbound toolkit (trigger provisioning, settings editor,
 * webhook URL display, connection minting).
 */
import type { InboundProviderPresenter } from '@/lib/integrations/inbound/types'

import {
  STYTCH_EVENT_CATEGORIES,
  STYTCH_EVENT_METADATA,
} from './supported-events'

export const STYTCH_SIGNING_SECRET_PREFIX = 'whsec_'
export const STYTCH_SIGNING_SECRET_MIN_LENGTH = 24

export const stytchInboundPresenter: InboundProviderPresenter = {
  providerId: 'stytch',
  displayName: 'Stytch',
  signingSecretPrefix: STYTCH_SIGNING_SECRET_PREFIX,
  categories: STYTCH_EVENT_CATEGORIES,
  events: STYTCH_EVENT_METADATA,
  defaultTriggerLoop: true,
  triggerEventId({ orgId, brandId, eventType }) {
    return `stytch:${orgId}:${brandId}:${eventType}`
  },
}
